import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import t from "@zendesk/client-i18n-tools";

import {
  Input,
  Label,
  Message,
  TextField,
} from "@zendeskgarden/react-textfields";

export default class RuleNameField extends PureComponent {
  static propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
    showValidation: PropTypes.bool,
  };

  render() {
    const { onChange, showValidation, value } = this.props;

    const validation = showValidation ? "error" : "none";

    return (
      <TextField>
        <Label>{t("knowledge-verification.ruleName")}</Label>
        <Input
          data-test-id="rule-name-input"
          onChange={onChange}
          placeholder={t("knowledge-verification.ruleNamePlaceholder")}
          value={value}
          validation={validation}
        />
        <Message
          data-test-id="rule-name-validation"
          validation={validation}
          style={{ display: showValidation ? "inherit" : "none" }}
        >
          {t("knowledge-verification.ruleNameMissing")}
        </Message>
      </TextField>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/RuleNameField/index.js